import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.DryingTray.WetSoilMass`]: wrap([
    `${prefix}.DryingTray.ContainerMass`,
    `${prefix}.DryingTray.WetSoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTray.ConstantDrySoilMass`]: wrap([
    `${prefix}.DryingTray.ContainerMass`,
    `${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTray.ConstantDrySoilAndContainerMass`]: wrap([
    `${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTray.DryMassReadings.DrySoilMass`]: wrap([
    `${prefix}.DryingTray.ContainerMass`,
    `${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
